export const partiesLabel={
    consignor:{title:"CONSIGNOR",tableName:"consignorsList"},
    exporter:{title:"EXPORTER",tableName:"exportersList",boxNumber:"3/1"},
    consignee:{title:"CONSIGNEE",tableName:"consigneeList",boxNumber:"3/9"},
    representative:{title:"REPRESENTATIVE",tableName:"representativesList",boxNumber:"3/19"  },
    declarant:{title:"DECLARANT",tableName:"declarantsList",boxNumber:"3/17"},
    carrier:{title:"CARRIER",tableName:"carriersList",boxNumber:"3/7"}
}